import React,{useState,useEffect,useMemo} from 'react';
import Layout from '../components/Layout/Layout.js';
import axios from 'axios';
import { Prices } from '../components/Prices.js';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/cart.js';
import toast from 'react-hot-toast';
import "../styles/HomePage.css";
import { AiOutlineReload } from "react-icons/ai";
import QuickView from '../components/QuickView.js';

const HomePage = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [checked, setChecked] = useState([]);
  const [radio, setRadio] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useCart();
  const [quickViewProduct, setQuickViewProduct] = useState(null);
  const [sortOrder, setSortOrder] = useState('newest');
  const [filtersOpen, setFiltersOpen] = useState(false);

  const getAllCategory = async () => {
    try {
      const { data } = await axios.get("/api/v1/category/get-category");
      if (data?.success) {
        setCategories(data?.category);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCategory();
    getTotal();
  }, []);

  const getAllProducts = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/api/v1/products/get-product");
      setLoading(false);
      setProducts(data.products);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getTotal = async () => {
    try {
      const { data } = await axios.get("/api/v1/products/product-count");
      setTotal(data?.total);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (page === 1) return;
    loadMore();
    // eslint-disable-next-line
  }, [page]);

  const loadMore = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`/api/v1/products/product-list/${page}`);
      setLoading(false);
      setProducts([...products, ...data?.products]);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleFilter = (value, id) => {
    let all = [...checked];
    if (value) {
      all.push(id);
    } else {
      all = all.filter((c) => c !== id);
    }
    setChecked(all);
  };

  useEffect(() => {
    if (!checked.length || !radio.length) getAllProducts();
  }, [checked.length, radio.length]);

  useEffect(() => {
    if (checked.length || radio.length) filterProduct();
    // eslint-disable-next-line
  }, [checked, radio]);

  const filterProduct = async () => {
    try {
      const { data } = await axios.post("/api/v1/products/product-filters", {
        checked,
        radio,
      });
      setProducts(data?.products);
    } catch (error) {
      console.log(error);
    }
  };

  // New arrivals (must be defined before sortedProducts)
  const newArrivalIds = useMemo(() => {
    const sorted = [...products].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    return new Set(sorted.slice(0, 8).map(p => p._id));
  }, [products]);

  const newArrivals = useMemo(() => {
    return [...products].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 8);
  }, [products]);

  // Sort products — exclude new arrivals when no filters active
  const hasFilters = checked.length > 0 || radio.length > 0;
  const sortedProducts = useMemo(() => {
    if (!products) return [];
    const filtered = hasFilters ? products : products.filter(p => !newArrivalIds.has(p._id));
    const sorted = [...filtered];
    switch(sortOrder) {
      case 'price-low': return sorted.sort((a, b) => a.price - b.price);
      case 'price-high': return sorted.sort((a, b) => b.price - a.price);
      case 'name-az': return sorted.sort((a, b) => a.name.localeCompare(b.name));
      case 'newest':
      default: return sorted.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }
  }, [products, sortOrder, hasFilters, newArrivalIds]);

  // Top brands
  const topBrands = [
    { name: 'Apple', slug: 'apple', img: '/images/Apple-iPhone-15.jpg' },
    { name: 'Samsung', slug: 'samsung', img: '/images/zlip3.jpg' },
    { name: 'Xiaomi', slug: 'xiaomi', img: '/images/redminote11.jpg' },
    { name: 'OnePlus', slug: 'oneplus', img: '/images/oneplus2.png' },
    { name: 'Oppo', slug: 'oppo', img: '/images/opporeno.jpg' },
    { name: 'Vivo', slug: 'vivo', img: '/images/vivo.png' },
    { name: 'Realme', slug: 'realme', img: '/images/saimob1.png' },
    { name: 'Nothing', slug: 'nothing', img: '/images/nothing1.png' },
    { name: 'Huawei', slug: 'huawei', img: '/images/samsungs11.jpg' },
    { name: 'Tecno', slug: 'tecno', img: '/images/samsungfold.jpg' },
  ];

  const getCategoryCount = (catName) => {
    const cat = categories.find(c => c.name === catName);
    if (!cat) return 0;
    return products.filter(p => p.category === cat._id || p.category?._id === cat._id).length;
  };

  // Filter reset handler — Phase 1C
  const handleReset = () => {
    setChecked([]);
    setRadio([]);
  };

  return (
    <Layout title={'النخبة ستور | جميع المنتجات'}>

{/* ===== HERO CAROUSEL ===== */}
<div id="carouselExampleIndicators" className="carousel slide hero-carousel" data-bs-ride="carousel" data-bs-interval="4000">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={0} className="active" aria-current="true" aria-label="1" />
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={1} aria-label="2" />
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={2} aria-label="3" />
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src="/images/iphone15adpage.jpg" className="d-block w-100" alt="أحدث الهواتف" loading="lazy" />
      <div className="carousel-caption hero-caption">
        <div className="hero-logo-wrapper">
          <img src="/images/logo1.jpeg" alt="النخبة" className="hero-logo" />
        </div>
        <h1 className="hero-title">النخبة ستور</h1>
        <p className="hero-subtitle">عنوان الفخامة والرقي</p>
        <button className="btn btn-gold-shimmer mt-3" onClick={() => document.getElementById('products-section')?.scrollIntoView({behavior:'smooth'})}>
          تسوّق الآن
        </button>
      </div>
    </div>
    <div className="carousel-item">
      <img src="/images/banner2.jpg" className="d-block w-100" alt="أحدث العروض" loading="lazy" />
      <div className="carousel-caption hero-caption">
        <h2 className="hero-title">iPhone 17 Pro Max</h2>
        <p className="hero-subtitle">أحدث هواتف ابل متوفرة الآن بأفضل الأسعار</p>
        <button className="btn btn-gold-shimmer mt-3" onClick={() => navigate('/category/apple')}>
          تصفح هواتف Apple
        </button>
      </div>
    </div>
    <div className="carousel-item">
      <img src="/images/banner3.jpg" className="d-block w-100" alt="عروض حصرية" loading="lazy" />
      <div className="carousel-caption hero-caption">
        <h2 className="hero-title">عروض حصرية</h2>
        <p className="hero-subtitle">توصيل سريع لجميع المحافظات العراقية</p>
        <button className="btn btn-gold-shimmer mt-3" onClick={() => navigate('/categories')}>
          اكتشف العروض
        </button>
      </div>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true" />
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true" />
  </button>
</div>

{/* ===== TRUST BADGES ===== */}
<div className="trust-badges">
  <div className="container">
    <div className="trust-badges-grid">
      <div className="trust-badge-card">
        <div className="trust-badge-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M13 16V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1"/><path d="M13 6h3l4 4v6a1 1 0 0 1-1 1h-1"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="17.5" cy="17.5" r="1.5"/><path d="M9 17h4"/></svg>
        </div>
        <div className="trust-badge-text">
          <h6>توصيل سريع لكل العراق</h6>
          <p>شحن مجاني لجميع المحافظات</p>
        </div>
      </div>
      <div className="trust-badge-card">
        <div className="trust-badge-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>
        </div>
        <div className="trust-badge-text">
          <h6>ضمان أصلي 100%</h6>
          <p>جميع المنتجات أصلية ومكفولة</p>
        </div>
      </div>
      <div className="trust-badge-card">
        <div className="trust-badge-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/><path d="M7 15h2"/><path d="M13 15h4"/></svg>
        </div>
        <div className="trust-badge-text">
          <h6>دفع آمن ومتعدد</h6>
          <p>نقدي أو إلكتروني عند الاستلام</p>
        </div>
      </div>
      <div className="trust-badge-card">
        <div className="trust-badge-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
        </div>
        <div className="trust-badge-text">
          <h6>استبدال واسترجاع</h6>
          <p>استرجاع مجاني خلال 7 أيام</p>
        </div>
      </div>
    </div>
  </div>
</div>

{/* ===== NEW ARRIVALS ===== */}
{newArrivals.length > 0 && !hasFilters && (
<div className="new-arrivals-section">
  <div className="container">
    <h2 className="section-heading">
      <span className="heading-line"></span>
      وصل حديثاً
      <span className="heading-line"></span>
    </h2>
    <div className="new-arrivals-scroll">
      {newArrivals.map((p, index) => (
        <div className="card product-card" key={p._id} style={{animationDelay: `${index * 0.08}s`, flexShrink: 0}}>
          <div className="new-badge">جديد</div>
          <div className="card-img-wrapper">
            <button className="qv-trigger" type="button" onClick={() => setQuickViewProduct(p)} title="عرض سريع" aria-label="عرض سريع">👁</button>
            <img src={`/api/v1/products/product-photo/${p._id}`} className="card-img-top" alt={p.name} loading="lazy" onClick={() => setQuickViewProduct(p)} style={{cursor:'pointer'}} />
          </div>
          <div className="card-body">
            <h5 className="card-title">{p.name}</h5>
            <h5 className="card-title card-price">
              {p.price.toLocaleString("ar-IQ")} د.ع
            </h5>
          </div>
          <div className="card-name-price">
            <button className="btn btn-glass ms-1" onClick={() => setQuickViewProduct(p)}>التفاصيل</button>
            <button className="btn btn-gold-shimmer ms-1" onClick={() => {
              setCart([...cart, p]);
              localStorage.setItem("cart", JSON.stringify([...cart, p]));
              toast.success("تمت الإضافة إلى السلة");
            }}>أضف إلى السلة</button>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
)}

{/* ===== FEATURED BRANDS ===== */}
<div className="featured-brands">
  <div className="container">
    <h2 className="section-heading">
      <span className="heading-line"></span>
      أبرز العلامات التجارية
      <span className="heading-line"></span>
    </h2>
    <div className="brands-grid">
      {topBrands.map((brand, i) => (
        <div className="brand-card" key={brand.slug} onClick={() => navigate(`/category/${brand.slug}`)} style={{animationDelay: `${i * 0.08}s`}}>
          <img src={brand.img} alt={brand.name} />
          <div className="brand-overlay">
            <div className="brand-overlay-content">
              <span className="brand-name">{brand.name}</span>
              {getCategoryCount(brand.name) > 0 && (
                <span className="brand-count">{getCategoryCount(brand.name)} منتج</span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
    <div className="text-center mt-4">
      <button className="btn btn-glass" onClick={() => navigate('/categories')}>
        عرض جميع الأقسام ({categories.length})
      </button>
    </div>
  </div>
</div>

{/* ===== PRODUCTS SECTION ===== */}
<div className="gold-divider"></div>
<div id="products-section" className="container home-page">

  {/* Top bar: title + filters + sort */}
  <div className="products-topbar">
    <h2 className='section-heading' style={{marginTop:0, marginBottom: 0}}>
      <span className="heading-line"></span>
      جميع المنتجات ({total})
      <span className="heading-line"></span>
    </h2>

    <div className="topbar-controls">
      {/* Category filter chips */}
      <div className="filter-chips-wrapper">
        <button
          className={`filter-chip ${checked.length === 0 ? 'active' : ''}`}
          onClick={handleReset}
        >
          الكل
        </button>
        {categories?.map((c) => (
          <button
            key={c._id}
            className={`filter-chip ${checked.includes(c._id) ? 'active' : ''}`}
            onClick={() => {
              if (checked.includes(c._id)) {
                handleFilter(false, c._id);
              } else {
                handleFilter(true, c._id);
              }
            }}
          >
            {c.name}
          </button>
        ))}
      </div>

      {/* Price + Sort row */}
      <div className="topbar-selects">
        <select
          className="sort-select"
          value={radio.length > 0 ? JSON.stringify(radio) : ''}
          onChange={(e) => setRadio(e.target.value ? JSON.parse(e.target.value) : [])}
          aria-label="فلتر السعر"
        >
          <option value="">جميع الأسعار</option>
          {Prices?.map((p) => (
            <option key={p._id} value={JSON.stringify(p.array)}>{p.name}</option>
          ))}
        </select>

        <select
          className="sort-select"
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
          aria-label="ترتيب المنتجات"
        >
          <option value="newest">الأحدث</option>
          <option value="price-low">السعر: من الأقل</option>
          <option value="price-high">السعر: من الأعلى</option>
          <option value="name-az">الاسم: أ-ي</option>
        </select>
      </div>
    </div>
  </div>

  {/* Active filter tags */}
  {(checked.length > 0 || radio.length > 0) && (
    <div className="active-filters">
      {checked.map(id => {
        const cat = categories.find(c => c._id === id);
        return cat ? (
          <span className="filter-tag" key={id} onClick={() => handleFilter(false, id)}>{cat.name} ×</span>
        ) : null;
      })}
      {radio.length > 0 && (
        <span className="filter-tag" onClick={() => setRadio([])}>فلتر السعر ×</span>
      )}
      <span className="filter-tag filter-tag-reset" onClick={handleReset}>مسح الكل</span>
    </div>
  )}

  {/* Products grid — full width */}
  <div className='d-flex flex-wrap justify-content-center'>
    {loading && products.length === 0 && (
      <div className="d-flex flex-wrap justify-content-center">
        {[...Array(6)].map((_, i) => (
          <div className="skeleton skeleton-card" key={i} style={{animationDelay: `${i * 0.1}s`}}></div>
        ))}
      </div>
    )}
    {sortedProducts?.map((p, index) => (
      <div className="card product-card m-2" key={p._id} style={{animationDelay: `${index * 0.08}s`}}>
        <div className="card-img-wrapper">
          <button className="qv-trigger" type="button" onClick={() => setQuickViewProduct(p)} title="عرض سريع" aria-label="عرض سريع">👁</button>
          <img src={`/api/v1/products/product-photo/${p._id}`} className="card-img-top" alt={p.name} loading="lazy" onClick={() => setQuickViewProduct(p)} style={{cursor:'pointer'}} />
        </div>
        <div className="card-body">
          <h5 className="card-title">{p.name}</h5>
          <h5 className="card-title card-price">
            {p.price.toLocaleString("ar-IQ")} د.ع
          </h5>
        </div>
        {p.description && (
          <p className="card-text">{p.description}</p>
        )}
        <div className="card-name-price">
          <button className="btn btn-glass ms-1" onClick={() => setQuickViewProduct(p)}>التفاصيل</button>
          <button className="btn btn-gold-shimmer ms-1" onClick={() => {
            setCart([...cart, p]);
            localStorage.setItem("cart", JSON.stringify([...cart, p]));
            toast.success("تمت الإضافة إلى السلة");
          }}>أضف إلى السلة</button>
        </div>
      </div>
    ))}
    {!loading && products?.length === 0 && (
      <div className="empty-state">
        <div className="empty-state-icon">📱</div>
        <h4>لا توجد منتجات حالياً</h4>
        <p>يرجى المحاولة لاحقاً أو إعادة تحميل الصفحة</p>
      </div>
    )}
  </div>

  <div className='m-2 p-3 text-center'>
    {products && products.length < total && (
      <button className='btn btn-gold-shimmer' onClick={(e) => {
        e.preventDefault();
        setPage(page + 1);
      }}>
        {loading ? "جاري التحميل ..." : (<>عرض المزيد <AiOutlineReload /></>)}
      </button>
    )}
  </div>
</div>

{/* ===== PROMO BANNER ===== */}
<div className="promo-banner">
  <div className="promo-content">
    <div className="promo-text">
      <h3>أحدث هواتف iPhone 17 متوفرة الآن</h3>
      <p>تشكيلة واسعة من أفضل العلامات التجارية العالمية بأسعار تنافسية مع ضمان أصلي وتوصيل لجميع المحافظات</p>
      <button className="btn btn-gold-shimmer" onClick={() => navigate('/category/apple')}>تسوّق iPhone 17</button>
    </div>
    <div className="promo-image">
      <img src="/images/iphone15blue.png" alt="أحدث الهواتف" />
    </div>
  </div>
</div>

{quickViewProduct && (
  <QuickView product={quickViewProduct} onClose={() => setQuickViewProduct(null)} />
)}
</Layout>
  );
};

export default HomePage;
